const Footer = () => {
  return (
    <footer>
      <p className="text-sm">&copy; {new Date().getFullYear()} Fawaz Oyedeji. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
